/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FinesQuestion.module.scss'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { clearAllAction, screenLoadingAction } from 'redux/actions'
import { registerAndLogin } from 'redux/reducers/apiReducers/registerReducer'
import { logoutAction } from 'redux/reducers/apiReducers/authenticationReducer'
import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'
import axios from 'axios'
import moment from 'moment'
import BackAnchor from '../../../../shared/components/BackAnchor'
import PrivacyStatement from './PrivacyStatement'

const FinesQuestionView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [errMsg, setErrMsg] = useState('')
  const [outageRichTexts, setOutageRichTexts] = useState([])
  const [outageStartDate, setOutageStartDate] = useState('')
  const [outageEndDate, setOutageEndDate] = useState('')
  const dateNow = moment().toDate()
  const outageUrl = window.location.origin + '/services/outageservice/api/outage-events'
  const [serviceFlag, setServiceFlag] = useState(false)
  const [dateFlag, setDateFlag] = useState(false)
  const [outageActive, setOutageActive] = useState(false)
  const [disableFlag, setDisableFlag] = useState(false)
  const [warningStartDate, setWarningStartDate] = useState('')
  const [warningEndDate, setWarningEndDate] = useState('')
  const [warningRichTexts, setWarningRichTexts] = useState([])
  const [warningFlag, setWarningFlag] = useState(false)
  const [warningActive, setWarningActive] = useState(false)
  const [warningServiceFlag, setWarningServiceFlag] = useState(false)
  const warnEventUrl = window.location.origin + '/services/outageservice/api/warning-events'

  const sendGetRequest = async () => {
    try {
      const res = await axios.get(outageUrl)
      const events = res.data
      const now = moment().toDate()
      const activeTexts = []
      for (const event of events) {
        const services = event.services || ''
        const isServiceAffected = services.split(',').includes('PAYPRIVILEGEREINSTATEMENT') || services.split(',').includes('ALLSERVICES')
        const startDate = moment(event.outageStart).toDate()
        const endDate = moment(event.outageEnd).toDate()
        const isDateInRange = now > startDate && now < endDate
        if (event.enabled === true && isServiceAffected && isDateInRange) {
          activeTexts.push(event.outageRichText)
          setOutageActive(true)
          setServiceFlag(true)
          setDateFlag(true)
          setDisableFlag(true)
        }
      }
      setOutageRichTexts(activeTexts)
    } catch (err) {
      console.error(err)
    }
  }

  const sendWarnGetRequest = async () => {
    try {
      const res = await axios.get(warnEventUrl)
      const events = res.data
      const now = moment().toDate()
      const activeWarnTexts = []
      for (const event of events) {
        const services = event.services || ''
        const isServiceAffected = services.split(',').includes('PAYPRIVILEGEREINSTATEMENT') || services.split(',').includes('ALLSERVICES')
        const startDate = moment(event.warningStartDate).toDate()
        const endDate = moment(event.warningEndDate).toDate()
        const isDateInRange = now > startDate && now < endDate
        if (event.enabled === true && isServiceAffected && isDateInRange) {
          activeWarnTexts.push(event.warningMessageText)
          setWarningActive(true)
          setWarningServiceFlag(true)
          setWarningFlag(true)
        }
      }
      setWarningRichTexts(activeWarnTexts)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    sendGetRequest()
    sendWarnGetRequest()
  }, [])

  const momentOutageStartDate = moment(outageStartDate).toDate()
  const momentOutageEndDate = moment(outageEndDate).toDate()
  const momentWarningStartDate = moment(warningStartDate).toDate()
  const momentWarningEndDate = moment(warningEndDate).toDate()

  useEffect(() => {
    if (dateNow > momentOutageStartDate && dateNow < momentOutageEndDate) {
      setDateFlag(true)
    }
  }, [momentOutageStartDate, momentOutageEndDate])

  useEffect(() => {
    if (dateNow > momentWarningStartDate && dateNow < momentWarningEndDate) {
      setWarningFlag(true)
    }
  }, [momentWarningStartDate, momentWarningEndDate])

  useEffect(() => {
    if (dateFlag && serviceFlag && outageActive) {
      setDisableFlag(true)
    }
  }, [dateFlag, serviceFlag, outageActive])

  useEffect(() => {
    try {
      dispatch(clearAllAction())
      dispatch(logoutAction()).catch((e) => {
        console.log(e)
      })
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const checkCookiesEnabled = () => {
    try {
      var cookieEnabled = navigator.cookieEnabled
      if (!cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1
        if (cookieEnabled) {
          return true
        } else {
          setErrMsg('privacy_notice.enable_cookies')
        }
      }
      return cookieEnabled
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const handleYes = () => {
    checkRegisterAndLogin('routes.fines_yes')
  }

  const handleNo = () => {
    checkRegisterAndLogin('routes.your_info')
  }

  const checkRegisterAndLogin = (nextStep) => {
    try {
      if (checkCookiesEnabled()) {
        dispatch(screenLoadingAction())
        dispatch(getServiceAvailableAction())
          .then((res) => {
            // if (true) {
            if (res['data']) {
              dispatch(registerAndLogin())
                .then(() => {
                  dispatch(screenLoadingAction())
                  history.push(`/${i18n.language}${t(nextStep)}`)
                })
                .catch((e) => {
                  dispatch(screenLoadingAction())
                  console.log(e)
                  setErrMsg('privacy_notice.server_error')
                })
            } else {
              dispatch(screenLoadingAction())
              setErrMsg('privacy_notice.service_not_available_error')
            }
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setErrMsg('privacy_notice.service_not_available_error')
          })
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  function Banner() {
    if (disableFlag === true) {
      return (
        <>
          {outageRichTexts.map((text, index) => (
            <div key={index} className="alert-medium" data-gtm-vis-first-on-screen-9622674_25="908" data-gtm-vis-total-visible-time-9622674_25="100" data-gtm-vis-has-fired-9622674_25="1" data-gtm-vis-first-on-screen-9622674_29="912" data-gtm-vis-total-visible-time-9622674_29="100" data-gtm-vis-has-fired-9622674_29="1">
              <p className="no-margin"><span>{text}</span></p>
            </div>
          ))}
        </>
      )
    }
    return null
  }

  function WarningBanner() {
    if (warningFlag === true && disableFlag === false && warningServiceFlag === true && warningActive === true) {
      return (
        <>
          {warningRichTexts.map((text, index) => (
            <div key={index} className="alert-medium" data-gtm-vis-first-on-screen-9622674_25="908" data-gtm-vis-total-visible-time-9622674_25="100" data-gtm-vis-has-fired-9622674_25="1" data-gtm-vis-first-on-screen-9622674_29="912" data-gtm-vis-total-visible-time-9622674_29="100" data-gtm-vis-has-fired-9622674_29="1">
              <p className="no-margin"><span>{text}</span></p>
            </div>
          ))}
        </>
      )
    }
    return null
  }

  const [showPrivacyStatement, setShowPrivacyStatement] = useState(false)

  const togglePrivacyStatement = useCallback((e) => {
    e.preventDefault()
    setShowPrivacyStatement((prevState) => !prevState)
  }, [])

  const privacyToggleIcon = useMemo(() => (showPrivacyStatement ? 'fa-minus' : 'fa-plus'), [showPrivacyStatement])

  return (
    <div className="container">
      <BackAnchor
        isInternal={false}
        backPath={
          i18n.language === 'fr'
            ? 'https://beta.novascotia.ca/fr/paiement-des-frais-de-retablissement-de-permis-de-conduire-bureau-des-vehicules-automobiles'
            : 'https://beta.novascotia.ca/pay-privilege-reinstatement-fee-registry-motor-vehicles'
        }
      />
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <Banner />
          <WarningBanner />
          <h3>{t('defaulted_fines.do_you_have')}</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12" style={{ marginTop: '-45px' }}>
          <button
            disabled={disableFlag}
            className={'btn-lg btn-default'}
            onClick={handleYes}
            value={t('defaulted_fines.yes')}
            name={t('defaulted_fines.yes')}
          >
            {t('defaulted_fines.yes')}
          </button>
          <button
            disabled={disableFlag}
            className={['btn-lg btn-default', styles['margin_left_20']].join(' ')}
            onClick={handleNo}
            value={t('defaulted_fines.no')}
            name={t('defaulted_fines.no')}
          >
            {t('defaulted_fines.no')}
          </button>
        </div>
      </div>

      <div className="row" style={{ marginBottom: '2rem' }}>
        <div className="col-xs-12 col-lg-8">
          <hr />
          <br />
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <i
              aria-label={t('shared.error')}
              className="fa fa-lock fa-lg"
              aria-hidden="true"
              style={{ color: '#0058a4', marginTop: '3px' }}
            ></i>
            <a href="#" style={{ display: 'flex', marginBottom: '2rem' }} id="toggle-privacy-statement" onClick={togglePrivacyStatement}>
              {t('defaulted_fines.personal_question')}
            </a>
            <i
              aria-label={t('shared.error')}
              className={`fa fa-lg ${privacyToggleIcon}`}
              aria-hidden="true"
              style={{ color: '#0058a4', marginTop: '3px' }}
            ></i>
          </div>
          {showPrivacyStatement && <PrivacyStatement />}
          <hr />
          <br />
        </div>
      </div>
      {errMsg !== '' && (
        <div className="row has-error">
          <div className="col-xs-12">
            <i className="fa fa-exclamation-circle" aria-hidden="true" /> {t(errMsg)}
          </div>
        </div>
      )}
    </div>
  )
}

export default withTranslation('common')(FinesQuestionView)
